import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import { getPagesData } from "../Actions/PagesAction";

const getPagesInformation = () => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.get(Apis.getPagesInformation);
        if (response?.status == 200) {
          dispatch(getPagesData(response.data.data));
          resolve(true);
        }
      } catch (error) {
        reject(error);
        dispatch(
          showAlert({
            title: "Advertisement",
            message: error?.response?.data?.message,
            type: "Error",
            status: error?.response?.status,
          })
        );
      }
    });
  };
};

export default { getPagesInformation };
